import React,{useState, useEffect} from 'react';
import axios from 'axios'
import Inner from '../components/Inner';
import Generated from './Generated';

const Dashboard = ({code}) => {
  const [mounted, setMount] = useState(false)
  const [user, setUser] = useState();
  const [data, setData] = useState();

  useEffect(() => {
    if(!mounted) {
      axios.post('https://dribbbler-player-card-endpoint-ztm8i.ondigitalocean.app/get-token', null, { 
        params: {
          code: code
        }
      }).then((res) => {
        setUser(res.data.account_info);
        if(res.data.post_info.length > 1) {
          setData(res.data.post_info);
        }
      })
      .catch((error) => console.log(error))
    }
    setMount(true);
    
  }, [mounted, code, data, user]);

  const Stuff = () => {
    if(data && user) {
      
      let view_count = 0
      let likes_count = 0;

      for(let i = 0; i < data.length; i++) {
        view_count = view_count + parseInt(data[i].views)
        likes_count = likes_count + parseInt(data[i].likes)
      }

      let shot_count = data.length
      return (
          <Generated
            user={user} 
            likes_count={likes_count} 
            view_count={view_count}
            shot_count={shot_count}
          />
      )
    } else {
      return (
        <Inner>
          <div className="generating">
            <div className="generating__loader"></div>
            <h4>Generating Card (could take a minute or two)...</h4>
          </div>
        </Inner>
      )
    }
  }
  return (
    <div>
      <Stuff/>
    </div>
  )
}

export default Dashboard